import React,{useState} from 'react';
import { useNavigate } from '@plasma/ui.application.router';
import { Icon } from '@plasma/ui.general.icon';


interface TopBarProps {
      topHeading: string;
      headingBGColor: string;
      showHome?: boolean
}

const TopBar: React.FC<TopBarProps> = ({
                  topHeading,
                  headingBGColor,
                  showHome = true
              }) => {

  const companyId= sessionStorage.getItem('companyID');
  const superUserRole= sessionStorage.getItem('superUserRole');
  const navigate = useNavigate();

  //console.log('role: ', superUserRole);

  const handleGoHome = () => {
    superUserRole === 'Ts-admin' ? ((companyId?.length && superUserRole === 'Ts-admin') ? navigate('/home-screen') : navigate('/create-new-project')) : navigate('/home-screen');
  };


  return (

    <div style={{
      display: 'flex',
      flexDirection: 'row',
      justifyContent: 'space-between',
      alignItems: 'center',
      marginTop: '',
      padding: '1vh',
    }}>

      {showHome && <Icon
        name={'Home'}
        title="Go Home"
        style={{
          fontSize: '1.9vw',
          color: 'white',
          padding: '0.5vh',
          height: 'fit-content',
          width: 'fit-content',
          backgroundColor: '#5B9AE1',
          borderRadius: '0.5vh',
        }}
        onClick={() => handleGoHome()}
      />}

      <div
        style={{
          fontSize: '2vh',
          fontWeight: 'bold',
          borderBottom: '1px solid black',
          marginLeft: 'auto',
          marginRight: 'auto',
          backgroundColor: headingBGColor,
          padding: '0.5vh 1vh',
          borderRadius: '0.5vh'
        }}
      >
        {topHeading}
      </div>

      <div style={{marginRight: showHome ? '6vw' : '0'}}/>
    </div>

  );
};

export default TopBar;
